import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import LocationsSection from './components/LocationsSection';
import Footer from '../../../components/feature/Footer';

export default function VerdeCocinaPage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />

      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-zinc-900 mb-4">
            About Verde Cocina
          </h2>
          <p className="text-lg text-zinc-600 max-w-3xl mx-auto leading-relaxed">
            Verde Cocina is Juarez's premier plant-based dining destination, offering innovative vegetarian and 
            vegan cuisine that proves healthy eating can be delicious and exciting. We source fresh, local 
            ingredients to create colorful, nutrient-rich dishes that satisfy both your taste buds and your 
            wellness goals. From hearty grain bowls to creative plant-based entrees, our menu celebrates the 
            vibrant flavors of vegetables and whole foods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-leaf-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">100% Plant-Based</h3>
            <p className="text-zinc-600">Entirely vegetarian and vegan menu with creative dishes</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-seedling-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Fresh Local Ingredients</h3>
            <p className="text-zinc-600">Sourced from local farms for maximum freshness and flavor</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-pulse-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Health-Conscious</h3>
            <p className="text-zinc-600">Nutrient-rich meals designed for wellness and vitality</p>
          </div>
        </div>

        {/* Locations */}
        <LocationsSection />
      </div>

      <section className="bg-gradient-to-br from-orange-500 to-orange-600 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Visit Verde Cocina Today
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Experience innovative plant-based cuisine that's healthy and delicious
          </p>
          <Link
            to="/places-to-eat"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-full font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            Back to All Restaurants
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
